<div fxFlex="100%" fxLayout="row wrap" class="app-ic-media-payment"
    [ngStyle]="{ 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
    <!-- [ngClass]="{'web-view' : screenFrom == 'directive' , 'mobile-view' : screenFrom != 'directive'}"  -->

    <ng-container *ngIf="!isPaymentSuccess">
        <!-- Address Block START -->
        <div fxFlex="100%" fxLayout="row wrap" class="mb-15 amountLabel" [hidden]="showCCForm">
            <form fxFlex="100%" fxLayout="row wrap" [formGroup]="billingForm" autocomplete="off">
                <div fxFlex="100%" fxLayout="row" class="amount-field ptb-10 pr-0">
                    <h6 class="ff mt-10 mr-10 fs-18" fxFlex="55%" fxFlex.xs="65%">
                        <span
                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                            {{title}}
                        </span>
                    </h6>
                    <mat-form-field class="w-120 notranslate relative custom-no-underline"
                        [ngStyle]="{ 'background-color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : '', height:'60px', 'border-radius': '5px'}">
                        <div class="absolute">
                            <label class="notranslate"
                                [ngStyle]="{ 'color': settingsData.form_bg_color ? settingsData.form_bg_color : '' ,'font-family': settingsData.form_bg_color ? settingsData.form_bg_color : ''}">
                                {{(currency | currencySymbol)? (currency | currencySymbol) : (1000 | currencySymbol) }}
                            </label>
                        </div>
                        <input matInput disabled [ngStyle]="{
                            'color': settingsData.form_bg_color || null,
                            '-webkit-text-fill-color': settingsData.form_bg_color || null,
                            'opacity': '1',
                            'height': '42%'
                          }" type="number" min="0" allowValues autofocus="autofocus" isInputType="decimalWithTwoDigits"
                            class="amount-txt" formControlName="amount" required>
                        <mat-error *ngIf="billingForm.get('amount').hasError('required')">
                            Please enter amount
                        </mat-error>
                    </mat-form-field>
                </div>

                <div fxFlex="100%" class="paymentDetailsIc">
                    <mat-form-field class="w-100 h-46 pr-20"
                        [style.--form-border-color]="settingsData?.form_font_secondary_color">
                        <mat-label [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Currency</mat-label>
                        <mat-select [ngModelOptions]="{standalone: true}" [(ngModel)]="currencyVal"
                            (selectionChange)="changeCurrency($event)" required>
                            <mat-option [value]="currency" *ngFor="let currency of currenciesList">
                                {{currency}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="radio-btn w-100">
                    <div [hidden]="!userInfo?.id">
                        <app-default-address [settingsData]="settingsData"></app-default-address>
                    </div>
                </div>
                <ng-container
                    *ngIf="((savedCardsList?.length == 0 && addressList?.billingAddress?.length == 0) || showBillingForm)">
                    <div fxFlex="100%" class="mt-10">
                        <mat-form-field class="w-100"
                            [style.--form-border-color]="settingsData?.form_font_secondary_color">
                            <mat-label
                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                    Country </div>
                            </mat-label>
                            <!-- <mat-label>Country</mat-label> -->
                            <input matInput placeholder="" name="Country"
                                [style.color]="settingsData.form_font_secondary_color +'!important'"
                                [matAutocomplete]="auto" autocomplete="off" (input)="filterCountry()"
                                formControlName="country" required>
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                                (optionSelected)="selectCountry($event.option);" class="country-dropdown">
                                <mat-option *ngFor="let country of countriesList;" [value]="country">
                                    <span>{{country.name}}</span>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="billingForm.get('country').hasError('required')">
                                Please select country
                            </mat-error>
                            <mat-error *ngIf="!billingForm.get('country').hasError('required') && 
                        billingForm.get('country').hasError('mat-require-match')">
                                Please select country from existing list
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100%">
                        <mat-form-field class="w-100" *ngIf="countryChanged"
                            [style.--form-border-color]="settingsData?.form_font_secondary_color">
                            <mat-label>
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                    *ngIf="billingCountry.name != 'United Kingdom'">Address line 1</div>
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                    *ngIf="billingCountry.name == 'United Kingdom'">Address</div>
                            </mat-label>
                            <input matInput placeholder=""
                                [style.color]="settingsData.form_font_secondary_color + '!important'"
                                ngx-gp-autocomplete formControlName="address1" [options]="options"
                                (onAddressChange)="getSelectedAddress($event, 'billingForm')"
                                (paste)="onPasteLocation($event)" required />
                            <mat-error *ngIf="billingForm.get('address1').touched || billingForm.get('address1').dirty">
                                Please enter address
                            </mat-error>
                        </mat-form-field>
                        <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                    </div>
                    <div fxFlex="100%" *ngIf="billingCountry.name != 'United Kingdom'">
                        <mat-form-field class="w-100"
                            [style.--form-border-color]="settingsData?.form_font_secondary_color">
                            <mat-label>
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                    *ngIf="billingCountry.name != 'United Kingdom'">Address line 2</div>
                            </mat-label>
                            <input matInput [style.color]="settingsData.form_font_secondary_color + '!important'"
                                formControlName="address2">
                        </mat-form-field>
                    </div>

                    <div fxFlex="100%">
                        <mat-form-field class="w-100"
                            [style.--form-border-color]="settingsData?.form_font_secondary_color">
                            <mat-label>
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                    City</div>
                            </mat-label>
                            <input matInput placeholder="" formControlName="city"
                                [style.color]="settingsData.form_font_secondary_color + '!important'" required>
                            <mat-error *ngIf="billingForm.get('city').touched || billingForm.get('city').dirty">
                                Please enter city
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100%" *ngIf="billingCountry.name != 'United Kingdom'">
                        <mat-form-field class="w-100"
                            [style.--form-border-color]="settingsData?.form_font_secondary_color">
                            <mat-label>
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                    State</div>
                            </mat-label>
                            <input matInput formControlName="state"
                                [style.color]="settingsData.form_font_secondary_color + '!important'" required>
                            <mat-error *ngIf="billingForm.get('state').touched || billingForm.get('state').dirty">
                                Please enter state
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100%">
                        <mat-form-field class="w-100" *ngIf="billingCountry.name != 'United Kingdom'"
                            [style.--form-border-color]="settingsData?.form_font_secondary_color">
                            <mat-label>
                                <div class="d-inline-block"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                    Zip code</div>
                            </mat-label>
                            <input matInput placeholder=""
                                [style.color]="settingsData.form_font_secondary_color + '!important'"
                                formControlName="zip" required>
                            <mat-error *ngIf="billingForm.get('zip').touched || billingForm.get('zip').dirty">
                                Please enter zip code
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100" *ngIf="billingCountry.name == 'United Kingdom'">
                            <mat-label> <span
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''}">Postal
                                    code</span> </mat-label>
                            <input matInput placeholder=""
                                [style.color]="settingsData.form_font_secondary_color + '!important'"
                                formControlName="zip" required>
                            <mat-error *ngIf="billingForm.get('zip').touched || billingForm.get('zip').dirty">
                                Please enter postal code
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
                <div fxFlex="100%" class="mt-20">
                    <button mat-flat-button class="flat-primary-button mr-10 primary-bg-button" (click)="proceed()"
                        [style.background-color]="settingsData?.form_bg_secondary_color + '!important'"
                        [style.color]="settingsData?.form_font_primary_color + '!important'"
                        [disabled]="router.url.includes('subscriptionForm')">Proceed</button>
                    <button mat-flat-button fxHide.xs="true" class="flat-primary-button ml-20 primary-bg-button"
                        (click)="toggleSideMenuClose('close')" [disabled]="router.url.includes('subscriptionForm')"
                        [attr.style]="
  (settingsData.form_bg_primary_color 
    ? 'background-color: ' + settingsData.form_bg_primary_color + ' !important; ' 
    : '') +
  (settingsData.form_font_secondary_color 
    ? 'color: ' + settingsData.form_font_secondary_color + '!important; ' 
    : '')
">Cancel</button>
                    <a class="flat-secondary-button h-40 plr-25 ptb-8 ml-20" [attr.style]="
                    (settingsData.form_bg_primary_color 
                      ? 'background-color: ' + settingsData.form_bg_primary_color + ' !important; ' 
                      : '') +
                    (settingsData.form_font_secondary_color 
                      ? 'color: ' + settingsData.form_font_secondary_color + '; ' 
                      : '')
                  " fxShow.xs="true" fxHide target="_other" rel="nofollow" [href]="albumUrl">Cancel</a>
                </div>
            </form>
        </div>
        <!-- Address Block END -->


        <!-- Credit Card Block START -->
        <div fxFlex="100%" id="card-block" class="card-block" [hidden]="!showCCForm">
            <div class="display-block">
                <div fxLayout="row wrap">
                    <div class="mb-15 fw-600 w-100"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Billing Address
                    </div>
                    <div *ngIf="billingForm.get('address1').value && !selectedCard?.id"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        <i class="material-icons fs-13"> room </i>
                        {{billingForm.get('address1').value}}, <span
                            *ngIf="billingForm.get('address2').value">{{billingForm.get('address2').value}},</span><br>
                        {{billingForm.get('city').value}}, {{billingForm.get('state').value}},<br>
                        {{billingForm.get('country').value.name}}, {{billingForm.get('zip').value}}<br>
                        <span (click)="editAddress()" class="edit pointer fw-600 c-o">Edit</span>
                    </div>
                    <div *ngIf="selectedBillingAddress && selectedBillingAddress.line1"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        <i class="material-icons fs-13"> room </i>
                        {{selectedBillingAddress.line1}}, <span
                            *ngIf="selectedBillingAddress.line2">{{selectedBillingAddress.line2}},</span><br>
                        {{selectedBillingAddress.city}}, {{selectedBillingAddress.state}},<br>
                        {{selectedBillingAddress.country}}, {{selectedBillingAddress.zip}}<br>
                        <span (click)="showCCForm = false" class="edit pointer fw-600">Edit</span>
                    </div>
                </div>
                <div fxLayout="row wrap" *ngIf="taxable">
                    <div fxFlex="100%" class="mb-5 fw-600 mt-20"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Summary
                    </div>
                    <div fxLayoutAlign="start center" fxFlex="50%"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Items
                        <span *ngIf="incl" style="font-size: 12px;margin-left: 5px;margin-top: 5px;">
                            (Incl. VAT)
                        </span>
                    </div>
                    <div fxLayoutAlign="end center" fxFlex="50%" class="notranslate"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        {{billingForm.get('amount').value | currency:currency}}</div>
                    <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="bookingFee"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Booking Fee
                    </div>
                    <div fxLayoutAlign="end center" fxFlex="50%" class="notranslate" *ngIf="bookingFee"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        {{bookingFee | currency: currency}}
                    </div>
                    <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="!incl"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Estimated Tax</div>
                    <div *ngIf="!incl" fxLayoutAlign="end center" fxFlex="50%"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        {{taxAmount | currency: currency}} </div>
                    <!-- <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Processing Fee </div> -->
                    <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="processingFee && selectedTransaction =='ott'"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Processing Fee </div>
                    <div fxLayoutAlign="end center" fxFlex="50%" class="notranslate"
                        *ngIf="processingFee && selectedTransaction =='ott'"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        {{processingFee | currency: currency}}</div>
                    <div fxLayoutAlign="start center" fxFlex="50%" class="mt-10 pt-10 fs-20 total-row"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        Total</div>
                    <div fxLayoutAlign="end center" fxFlex="50%"
                        class="amount notranslate mt-10 pt-10 fs-20 total-row flex-column align-items-end"
                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}">
                        {{selectedTransaction =="ott" ? (finalAmount | currency: currency) : (amt_without_pf | currency:
                        currency)}} <br> <span *ngIf="selectedTransaction=='crypto'" matTooltip="{{crypto_amount}}"
                            class="fs-17">(<img src="{{cryptoSymbol}}" width="17px"
                                class="mb-1 mr-1" />{{sliced_crypto_amount}}...{{cryptoToken}})</span>
                    </div>
                </div>

                <!-- <div *ngIf="selectedPlan?.currency_type == 'USD'" fxFlex="100%" class="mt-30">
                    <div id="ps_checkout_load">
                    </div>

                    <div *ngIf="!reopen" id="ps_container_id" class="mb-20"></div>
                    <div *ngIf="reopen" id="ps_container_id" class="mb-20">
                        <div class="ps-checkout ps-checkout-visible ps-mode-embed">
                            <div class="ps-checkout-inner">
                                <div class="ps-checkout-content" style="height: 320px; width: 300px;"><iframe
                                        id="paystand_checkout_iframe" width="100%" height="100%" frameborder="0"
                                        src="https://checkout.paystand.co/v4/index.html"></iframe></div>
                            </div>
                        </div>
                    </div>
                    <button mat-flat-button fxHide.xs="true" fxShow class="flat-secondary-button ml-10" 
                    (click)="toggleSideMenuClose('close')">Cancel</button>
                </div> -->
                <!-- <div *ngIf="selectedPlan?.currency_type != 'USD'" > -->
                <app-payment-transactions (getTransactionDetails)="calFee($event)" [settingsData]="settingsData"
                    [currentBlock]="currentBlock"></app-payment-transactions>
                <!-- <div>
                    <form class="display-block" (ngSubmit)="makePayment()" class="checkout" [hidden]="selectedCard?.id">
                        <div id="form-field">
                            <div fxFlex="100%" class="text-center">
                                <div id="card-info" #cardInfo></div>
                                <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mt-20 mb-30">
                                    <mat-icon class="c-error">cancel
                                    </mat-icon>
                                    &nbsp;{{ cardError }}
                                </mat-error>
                                <div class="text-left app-merchandise">
                                    <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox"
                                        [ngModelOptions]="{standalone: true}" [(ngModel)]="save_card"
                                        (change)="saveCard($event)">
                                    </mat-checkbox><span class="pl-10">Save card for future payments</span>
                                </div>
                                <div class="pt-20">
                                    <button mat-flat-button class="flat-primary-button" id="submit-button" type="submit"
                                        [ngStyle]="{'background-color': settingsData.form_bg_secondary_color ? settingsData.form_bg_secondary_color : '' ,'color': settingsData.form_font_primary_color ? settingsData.form_font_primary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''  }">Pay</button>
                                    <button mat-flat-button fxHide.xs="true" fxShow class="flat-secondary-button ml-20"
                                        [ngStyle]="{'background-color': settingsData.form_bg_primary_color ? settingsData.form_bg_primary_color : '' , 
                                'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' }"
                                        (click)="toggleSideMenuClose('close')">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div *ngIf="!showBillingForm && !addNewCard && selectedCard?.id" class="text-center mt-20">
                        <button mat-flat-button class="flat-primary-button" id="submit-button"
                            (click)="makePayment('card')"
                            [ngStyle]="{'background-color': settingsData.form_bg_secondary_color ? settingsData.form_bg_secondary_color : '' ,'color': settingsData.form_font_primary_color ? settingsData.form_font_primary_color : '' ,'font-family': settingsData.font_family ? settingsData.font_family : ''  }">Pay</button>
                        <button mat-flat-button fxHide.xs="true" fxShow class="flat-secondary-button ml-20"
                            [ngStyle]="{'background-color': settingsData.form_bg_primary_color ? settingsData.form_bg_primary_color : '' , 
                                'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' }" (click)="toggleSideMenuClose('close')">Cancel</button>
                    </div>
                </div> -->
                <div class="text-center" *ngIf="paypalScript">
                    <hr>
                    <div id="paypal-button"></div>
                </div>
            </div>
        </div>
        <!-- Credit Card Block END -->
    </ng-container>

    <div *ngIf="isPaymentSuccess || isMobileAPP" id="payment_success" fxLayout="row wrap" fxFlex="100%"
        class="payment-box mt-40">
        <div fxLayout="row wrap" fxFlex="100%" class="payment-detail">
            <div fxFlex="100%"
                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : settingsData.form_font_secondary_color , 'font-family': settingsData.font_family ? settingsData.font_family : ''}"
                fxLayoutAlign="center center" class="text-center text-white d-block"
                [ngClass]="{'dynamic-text': settingsData.form_font_secondary_color}" [style.--dynamic-text-color]="settingsData.form_font_secondary_color">
                Payment completed successfully. <span *ngIf="isMobileAPP">Go to the application.</span>
            </div>
            <div fxFlex="100%" *ngIf="isMobileAPP" class="text-center mt-20 mb-20">
                <a class="flat-primary-button bg-light h-40 plr-25 ptb-10" [ngClass]="{
                    'dynamic-bg': settingsData.form_bg_secondary_color,
                    'dynamic-text': settingsData.form_font_primary_color,
                    'dynamic-font-family': settingsData.font_family
                }" [ngStyle]="{
                    '--dynamic-bg-color': settingsData.form_bg_secondary_color,
                    '--dynamic-text-color': settingsData.form_font_primary_color,
                    '--dynamic-font-family': settingsData.font_family
                }" fxShow.xs="true" fxHide
                    target="_other" rel="nofollow" [href]="albumUrl">Go To Album</a>
            </div>
        </div>
    </div>

</div>